import React, { memo, ReactElement } from 'react';
import { Box, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import classNames from 'classnames';

import { getIsMessageSent, getRedeemLink } from '../../../store/thanks/thanks.selectors';
import { getBranding } from '../../../../../store/branding/branding.selectors';
import { BrandingFields } from '../../../../../types/Branding.types';

import GiftCardReadyLink from './GiftCardReadyLink';

const GiftCardProcessing = (): ReactElement => {
  const redeemLink = useSelector(getRedeemLink) as string;
  const customBranding = useSelector(getBranding);
  const isMessageSent = useSelector(getIsMessageSent) as boolean;

  const tipText = (
    <>
      <Typography className={classNames('H4-Dark-Bold', 'textPrimary-ie')}>
        {customBranding[BrandingFields.giftCardConfirmationMessaging]}
      </Typography>
      <br />
      <Typography className={classNames('Body-Regular-Center-Static', 'textPrimary-ie')}>
        This can take upto 24 hours and it’s ok to close this page.
      </Typography>
      <br />
      <Typography className={classNames('Body-Regular-Center-Static', 'textPrimary-ie')}>
        As soon the gift card is available you will receive an email and will be able to start redeeming your gift card.
      </Typography>
    </>
  );

  return (
    <Box>
      {redeemLink && <GiftCardReadyLink link={redeemLink} />}
      {!redeemLink && !isMessageSent && (
        <Box textAlign="center" maxWidth={495} mx={[2, 'auto']}>
          {tipText}
        </Box>
      )}
      {!redeemLink && isMessageSent && (
        <Box
          bgcolor="yellow.sunflowerSuperLight"
          border={2}
          borderColor="yellow.sunflower"
          borderRadius="8px"
          textAlign="center"
          p={[2, 5]}
          maxWidth={520}
          mx={[4, 'auto']}
        >
          {tipText}
        </Box>
      )}
    </Box>
  );
};

export default memo(GiftCardProcessing);
